import React from "react";

export default function BetOddsWrapper(props) {
    let cols = props.children.length;
    if (cols === 1) {
        cols = 2;
    }

    if (props.columnLayout) {
        return (
            <div className="c_21_3" data-cols={cols}>
                {props.children}
            </div>
        );
    }

    return (
        <div className="c_21_2" data-cols={cols}>
            {props.children}
        </div>
    );
}
